import { FiShield, FiLock } from "react-icons/fi";

/** Presets for the Onaylar (permission-approves) page. */
export const APPROVAL_ACCESS_NOTICE_PRESETS = {
  "no-page": {
    icon: FiLock,
    title: "Bu sayfaya erişim yetkiniz bulunmuyor",
    lead: "Onaylar ekranını görüntülemek için kullanıcı profilinizde bu sayfa için yetki tanımlanmalıdır.",
    steps: [
      "Yöneticinizden veya profil sorumlusundan Kullanıcı Profilleri üzerinden erişim talep edin.",
      "Profilinize «Onaylar» sayfası için görüntüleme yetkisi eklendikten sonra oturumu yenileyin.",
    ],
    footer: "Sorun devam ederse sistem yöneticinize başvurun.",
  },
  "no-types": {
    icon: FiShield,
    title: "Onay türü yetkiniz tanımlı değil",
    lead: "Onaylar sayfasına erişiminiz var; ancak görüntüleyebileceğiniz onay türü henüz atanmamış.",
    steps: [
      "Kullanıcı Profilleri bölümünde profilinizi açın.",
      "«Onaylar» sayfası altındaki «Onay Türü Erişimi» alanından en az bir türü işaretleyin.",
      "Değişiklikten sonra oturumu kapatıp tekrar giriş yapın.",
    ],
    footer: "Tür seçimi yapılmadan onay kuyruğu listelenmez.",
  },
};
